import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=820f0836&"
import script from "./BaseLoading.vue?vue&type=script&lang=ts&"
export * from "./BaseLoading.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLoading.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports